import React, { useEffect, useState } from "react";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { toDate } from "date-fns";

const List = () => {
  const [receiveData, setReceiveData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputs, setInputs] = useState([]);
  const [data, setData] = useState();
  const [passSuccess, setpPassSuccess] = useState();
  const [currentPassword, setCurrentPassword] = useState("");
  const [user, setUser] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const formSubmit = async () => {
    setLoading(true);
    try {
      const response = await Http.get(
        `/shop-customer-information?mobile=${inputs.mobile}`
      );
      console.log(response);
      setReceiveData(response.data);
      setUser(response.data.id);
      setLoading(false);
    } catch (error) {
      console.error("Error on form submit:", error);
      setLoading(false);
    }
  };

  /*const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      console.log("Password updated!");
    }
    const response = await Http.post(
      `/retailer/customer-password-changes-by-moo-from-web/${receiveData.id}`,
      {
        newPassword,
        confirmPassword,
      }
    );
    setLoading(false);
  };*/
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setLoading(true); // Set loading to true during the API call
      try {
        const response = await Http.post(
          `/retailer/customer-password-changes-by-moo-from-web/${receiveData.id}`,
          {
            newPassword,
            confirmPassword,
          }
        );

        // Access `status` from `response.data`
        if (response.data.status === true) {
          // Optionally reset form fields and errors
          setNewPassword("");
          setConfirmPassword("");
          setErrors({});
          console.log("Password updated successfully!");
          setpPassSuccess(
            response.data.message || "Password updated successfully!"
          );
        } else {
          // Handle failure case
          setErrors({ apiError: response.data.message || "An error occurred" });
          setpPassSuccess(
            response.data.message || "An error occurred. Please try again!"
          );
        }
      } catch (error) {
        console.error("Error updating password:", error);
        setErrors({
          apiError: "Something went wrong. Please try again later.",
        });
        setpPassSuccess("An error occurred. Please try again!");
      } finally {
        setLoading(false); // Always set loading to false after the API call
      }
    }
  };

  const handleValidation = () => {
    const newErrors = {};
    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 4) {
      newErrors.newPassword = "Password must be at least 4 characters long";
    }
    if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {}, []);

  return (
    <div>
      <IsLogin />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Customer Searching by Mobile Number</h5>
          </div>
          <div className="am-pagebody">
            <div className="card pd-sm-40">
              <div className="row">
                <div className="col-lg">
                  <label htmlFor="">
                    <b>Customer Mobile Number</b>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={inputs.mobile}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-lg mt-4">
                  <button
                    className="btn btn-primary btn-block mg-b-10"
                    onClick={formSubmit}
                  >
                    <i className="fa fa-send mg-r-10"></i> Search
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-10 offset-1">
                <div className="card pd-sm-40">
                  <div className="card-body">
                    {receiveData ? (
                      <>
                        <div className="d-flex justify-content-between mb-3">
                          <h3 className="text-center">Customer information</h3>
                          <button
                            className="float-end btn btn-primary"
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          >
                            <i className="fa fa-edit"></i>
                          </button>
                        </div>

                        <table className="table">
                          <tr>
                            <th>Owner Name</th>
                            <td>{receiveData?.owner_name}</td>
                          </tr>
                          <tr>
                            <th>Shop Name</th>
                            <td>{receiveData?.shop_name}</td>
                          </tr>
                          <tr>
                            <th>Phone</th>
                            <td>{receiveData?.phone}</td>
                          </tr>
                          <tr>
                            <th>Email</th>
                            <td>{receiveData?.email}</td>
                          </tr>
                          <tr>
                            <th>Address</th>
                            <td>{receiveData?.address}</td>
                          </tr>
                          <tr>
                            <th>Nid No</th>
                            <td>{receiveData?.nid_no}</td>
                          </tr>
                          <tr>
                            <th>Division</th>
                            <td>{receiveData?.division?.name}</td>
                          </tr>
                          <tr>
                            <th>District</th>
                            <td>{receiveData?.district?.name}</td>
                          </tr>
                          <tr>
                            <th>Thana</th>
                            <td>{receiveData?.thana?.name}</td>
                          </tr>
                          <tr>
                            <th>Place</th>
                            <td>{receiveData?.place?.name}</td>
                          </tr>
                          <tr>
                            <th>Route</th>
                            <td>{receiveData?.route?.name}</td>
                          </tr>
                          <tr>
                            <th>Distributor</th>
                            <td>{receiveData?.distributor?.name}</td>
                          </tr>
                        </table>
                      </>
                    ) : (
                      <>
                        <h4 className="text-center text-danger">
                          Please Search Customer By Phone Number
                        </h4>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="exampleModalLabel">
                  Password Changes
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div
                      className={`mb-3 ${
                        errors.newPassword ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="newPassword" className="form-label">
                        New Password
                      </label>
                      <input
                        type="password"
                        className={`form-control ${
                          errors.newPassword ? "is-invalid" : ""
                        }`}
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      {errors.newPassword && (
                        <div className="invalid-feedback">
                          {errors.newPassword}
                        </div>
                      )}
                    </div>
                    <div
                      className={`mb-3 ${
                        errors.confirmPassword ? "has-error" : ""
                      }`}
                    >
                      <label htmlFor="confirmPassword" className="form-label">
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        className={`form-control ${
                          errors.confirmPassword ? "is-invalid" : ""
                        }`}
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      {errors.confirmPassword && (
                        <div className="invalid-feedback">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </div>
                    <h5 className="text-center text-success">{passSuccess}</h5>
                    <button type="submit" className="btn btn-primary">
                      Save changes
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
